module.exports = __webpack_public_path__ + "img/masterattender-locked.f6598fae.svg";